module.exports = __webpack_public_path__ + "img/47400.772a6310.jpg";